import { useEffect, useMemo, useState } from 'react'

import { type MoneyAmount } from 'types'

import { events, SessionContext } from '../shared'
import { CategoryFilter } from './CategoryFilter'
import { Footer } from './Footer'
import { Header } from './Header'
import { MarketplaceProducts } from './Products'
import { type MarketplaceProductCategory } from '../shared/types'

type MarketplaceProps = {
  balance?: MoneyAmount | null;
  member_id?: string | null;
  employer_id?: string | null;
  is_authenticated: boolean;
  public_view: boolean;
  public_referral_url: string;
}

export default function Marketplace ({
  balance,
  member_id: memberId,
  employer_id: employerId,
  is_authenticated: isAuthenticated,
  public_view: publicView,
  public_referral_url: publicReferralUrl,
}: MarketplaceProps) {
  const [activeCategory, setActiveCategory] = useState<MarketplaceProductCategory>('All')
  const [startTime, setStartTime] = useState<number>(Date.now())
  const sessionContext = useMemo(() => ({
    id: memberId ?? null,
    employerId: employerId ?? null,
    balance: balance ?? undefined,
    isAuthenticated,
    publicView,
    publicReferralUrl,
  }), [balance, employerId, isAuthenticated, memberId, publicReferralUrl, publicView])

  useEffect(() => {
    setStartTime(Date.now())
    events.emitProductsViewEvent(sessionContext)

    const handleBeforeUnload = () => {
      events.emitProductsExitEvent(sessionContext, Math.round((Date.now() - startTime) / 1000))
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [sessionContext])

  return (
    <SessionContext.Provider value={sessionContext}>
      <div className='@container'>
        <Header renderBalance={isAuthenticated && !!balance} />
        <CategoryFilter activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
        <MarketplaceProducts activeCategory={activeCategory} />
        <Footer />
      </div>
    </SessionContext.Provider>
  )
}
